import { ArrowElbowDownRight } from '@phosphor-icons/react';

export default ArrowElbowDownRight;
